import { Reducer } from 'redux';

import { publicStoreTypes, publicStoreState } from './types';

const INITIAL_STATE: publicStoreState = {
  ticketData: {
    selectedDay: null,
    date: null,
    selectedTravelGo: null,
    selectedTravelBack: null,
    finalStop: null,
    initialStop: null,
    isGoAndBack: false,
    profiles: [],
    carFares: { go: [], back: [] },
    carFareTaxes: { go: [], back: [] },
    ticketType: 'PASSENGER',
  },
  step: {
    go: {
      selected: false,
      completed: false,
      name: 'Selecionar ida',
      secondName: 'Selecionar nova data',
      toShow: true,
    },
    back: {
      selected: false,
      completed: false,
      name: 'Selecionar volta',
      toShow: false,
    },
    details: {
      selected: false,
      completed: false,
      name: 'Definir detalhes',
      toShow: true,
    },
    confirmRescheduling: {
      selected: false,
      completed: false,
      name: 'Confirmar reagendamento',
      toShow: false,
    },
    pay: { selected: false, completed: false, name: 'Pagar', toShow: true },
  },
  rescheduleData: {
    vehicleType: '',
    amount: 0,
    reschedule: null,
    tokenId: '',
    passengers: 0,
    stopId: '',
  },
  isCreateProfile: false,
  wrongParams: null,
};

const reducer: Reducer<publicStoreState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES SET_TO_PAY_DATA
    case publicStoreTypes.SET_TO_PAY_DATA:
      return {
        ...state,
        ticketData: action.payload,
      };

    // CASES SET_STEP
    case publicStoreTypes.SET_STEP:
      return {
        ...state,
        step: action.payload,
      };
    // CASES SET_RESCHEDULE_DATA
    case publicStoreTypes.SET_RESCHEDULE_DATA:
      return {
        ...state,
        rescheduleData: action.payload,
      };

    // CASES SET_IS_CREATE_PROFILE
    case publicStoreTypes.SET_IS_CREATE_PROFILE:
      return {
        ...state,
        isCreateProfile: action.payload,
      };

    // CASES LOGIN
    case publicStoreTypes.TICKET_SALES_LOGIN_REQUEST:
      return { ...state, loading: true };
    case publicStoreTypes.TICKET_SALES_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case publicStoreTypes.TICKET_SALES_LOGIN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        wrongParams: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
